/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { Nav, Tab, Dropdown } from "react-bootstrap";
import PerfectScrollbar from "react-perfect-scrollbar";
import HeaderDropdownToggle from "../content/CustomDropdowns/HeaderDropdownToggle";
import { ReactComponent as CompilingIcon } from "../../../_metronic/layout/assets/layout-svg-icons/Compiling.svg";
import { OverlayTrigger, Tooltip,Badge, Button } from "react-bootstrap";
import { FormattedMessage, injectIntl } from "react-intl";
import { TextField } from "@material-ui/core";
import { Formik } from "formik";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import {getNotifications, getAudit,updateNoti,getNotiCount,login,TOKEN_PREFIX 
 } from "../../crud/auth.crud";
 import {  format } from 'date-fns'
 import { Link } from "react-router-dom";
const perfectScrollbarOptions = {
  wheelSpeed: 2,
  wheelPropagation: false
};

export default class UserNotifications extends React.Component {
  state = { key: "Alerts",
      logs:[],
      notifications:[],
      sessionExpired:false,
      status:'',
      email:'',
   };

   loadAlerts=()=>
   {
     getNotifications()
    .then((response) => {
      this.setState({ notifications: response.data,notiCount:response.headers["x-total-records"] })
     // console.log(data);
     })
     .catch((error) => {
      if(error!=null && error!= undefined && error!="Error: Network Error")
      {
        const {status} = error.response;
        console.log("api response:::",status);
        if (status == "401") {
         this.setState({sessionExpired:true});
        }
      }
     });
   }

   loadEvents=()=>
   {
     getAudit().then(response => response.data)
    .then((data) => {
      this.setState({ logs: data })
      //console.log(data);
     });
    }

    updateNoti=(noti)=>
    {
      updateNoti(noti.id).then(response => response.data)
      .then((data) => {
        //this.setState({ logs: data })
        //console.log(data);
       });
      }      
    

   componentDidMount()
  {
    
    let email = localStorage.getItem(TOKEN_PREFIX+'_email');
    if(email !== undefined && email!==null)
    {
      this.setState({email:email});
    }
    
    getNotifications()
    .then((response) => {
      this.setState({ notifications: response.data,notiCount:response.headers["x-total-records"] })
     // console.log(data);
     });
    getAudit().then(response => response.data)
    .then((data) => {
      this.setState({ logs: data })
      //console.log(data);
     });

    const thisBoundedIncrementer = this.loadAlerts.bind(this);
     setInterval(thisBoundedIncrementer, 5000);
    }

  getHeaderTopBarCssClassList = () => {
    let result = "kt-header__topbar-icon ";
    if (this.props.pulse) {
      result += "kt-pulse kt-pulse--brand ";
    }

    const { iconType } = this.props;
    if (iconType) {
      result += `kt-header__topbar-icon--${iconType}`;
    }

    return result;
  };

  getSvgCssClassList = () => {
    let result = "kt-svg-icon ";
    const { iconType } = this.props;
    if (iconType) {
      result += `kt-svg-icon--${iconType}`;
    }

    return result;
  };

  getHetBackGroundCssClassList = () => {
    let result = "kt-head ";
    if (this.props.skin) {
      result += `kt-head--skin-${this.props.skin} `;
    }

    result += "kt-head--fit-x kt-head--fit-b";
    return result;
  };

  backGroundStyle = () => {
    if (!this.props.bgImage) {
      return "none";
    }

    return "url(" + this.props.bgImage + ")";
  };

  userNotificationsButtonCssClassList = () => {
    let result = "btn ";
    if (this.props.type) {
      result += `btn-${this.props.type} `;
    }

    result += "btn-sm btn-bold btn-font-md";
    return result;
  };

  ulTabsClassList = () => {
    let result = "nav nav-tabs nav-tabs-line nav-tabs-bold nav-tabs-line-3x  ";
    if (this.props.type) {
      result += `nav-tabs-line-${this.props.type} `;
    }

    result += "kt-notification-item-padding-x";
    return result;
  };

  render() {
    // eslint-disable-next-line no-unused-vars
    const { key } = this.state;
    const { useSVG, icon, pulse } = this.props;
    return (
      <>
       <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip id="notitooltip">Notifications</Tooltip>}
        >
      <Dropdown className="kt-header__topbar-item" drop="down" alignRight>
        <Dropdown.Toggle
          as={HeaderDropdownToggle}
          id="dropdown-toggle-user-notifications"
        >
          <span className={this.getHeaderTopBarCssClassList()}>
            {<i className={icon} />}
            <Badge variant="primary"><b>{this.state.notiCount}</b></Badge>
           

            {/*useSVG && (
              <span className={this.getSvgCssClassList()}>
                <CompilingIcon />
              </span>
            )*/}

            <span className="kt-pulse__ring" hidden={!pulse} />
          </span>
        </Dropdown.Toggle>

        <Dropdown.Menu className="dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-lg">
          <form>
            {/** Head */}
            <div
              className={this.getHetBackGroundCssClassList()}
              style={{ backgroundImage: this.backGroundStyle() }}
            >
              <h3 className="kt-head__title">
                User Notifications&nbsp;
                {/*<span className={this.userNotificationsButtonCssClassList()}>
                  23 new
                </span>*/}
              </h3>

              <Tab.Container
                defaultActiveKey={key}
                className={this.ulTabsClassList()}
              >
                <Nav
                  className={this.ulTabsClassList()}
                  onSelect={_key => this.setState({ key: _key })}
                >
                  <Nav.Item className="nav-item">
                    <Nav.Link eventKey="Alerts" className="nav-link show" onClick={this.loadAlerts}>
                      Alerts ({this.state.notiCount})
                    </Nav.Link>
                  </Nav.Item>
                  {/*<Nav.Item>
                    <Nav.Link eventKey="Events" className="nav-link show" >
                      Events 
                    </Nav.Link>
                  </Nav.Item>*/}
                  <Nav.Item>
                    <Nav.Link eventKey="Logs" className="nav-link show" onClick={this.loadEvents}>
                      Logs
                    </Nav.Link>
                  </Nav.Item>
                </Nav>

                <Tab.Content>
                  <Tab.Pane eventKey="Alerts">
                    <PerfectScrollbar
                      options={perfectScrollbarOptions}
                      style={{ maxHeight: "100vh", position: "relative" }}
                    >
                      <div
                        className="kt-notification kt-margin-t-10 kt-margin-b-10"
                        style={{ maxHeight: "40vh", position: "relative" }}
                      >
                        <div
                          className="kt-notification kt-margin-t-10 kt-margin-b-10 kt-scroll"
                          data-scroll="true"
                          data-height="300"
                          data-mobile-height="200"
                        >
                          
                          {this.state.notifications!=null && this.state.notifications.map((noti)=>(
                              <a className="kt-notification__item" key={noti.id}>
                            <div className="kt-notification__item-icon">
                              <i className="flaticon2-box-1 kt-font-brand" />
                            </div>
                            <div className="kt-notification__item-details">
                              <div className="kt-notification__item-title">

                                {noti.link!=null && noti.linkParam!=null &&
                                  <Link to={{pathname:noti.link,notification:{noti}, data: {[noti.linkObject]:noti.linkParam}}}>{noti.message}</Link>
                                  }
                                   {noti.link!=null && noti.linkParam==null &&
                                  <Link to={{pathname:noti.link}}>{noti.message}</Link>
                                  }
                                  {noti.link==null &&
                                        noti.message
                                  }
                              </div>
                              <div className="kt-notification__item-time">
                                {format(new Date(noti.createdOn), 'MM/dd/yyyy hh:ss')}
                              </div>
                            </div>
                          </a>

                          ))}
                          
                         
                          {/*<a className="kt-notification__item kt-notification__item--read">
                            <div className="kt-notification__item-icon">
                              <i className="flaticon2-safe kt-font-primary" />
                            </div>
                            <div className="kt-notification__item-details">
                              <div className="kt-notification__item-title">
                                Company meeting canceled
                              </div>
                              <div className="kt-notification__item-time">
                                19 hrs ago
                              </div>
                            </div>
                          </a>*/}
                          
                        </div>
                      </div>
                    </PerfectScrollbar>
                  </Tab.Pane>
                  <Tab.Pane eventKey="Logs" >
                    <PerfectScrollbar
                      options={perfectScrollbarOptions}
                      style={{ maxHeight: "100vh", position: "relative" }}
                    >
                      <div
                        className="kt-notification kt-margin-t-10 kt-margin-b-10"
                        style={{ maxHeight: "40vh", position: "relative" }}
                      >
                        <div
                          className="kt-notification kt-margin-t-10 kt-margin-b-10 kt-scroll"
                          data-scroll="true"
                          data-height="300"
                          data-mobile-height="200"
                        >
                        {this.state.logs!=null && this.state.logs.map((log)=>(
                            <a className="kt-notification__item" key={log.id}>
                            <div className="kt-notification__item-icon">
                              <i className="flaticon2-psd kt-font-success" />
                            </div>
                            <div className="kt-notification__item-details">
                              <div className="kt-notification__item-title">
                                {log.activity}
                              </div>
                              <div className="kt-notification__item-time">
                                 {format(new Date(log.createdOn), 'MM/dd/yyyy hh:ss')}
                              </div>
                            </div>
                          </a>

                          ))}
                          
                          
                        </div>
                      </div>
                    </PerfectScrollbar>
                  </Tab.Pane>
                 {/*<Tab.Pane eventKey="Logs">
                    <div
                      className="kt-grid kt-grid--ver"
                      style={{ minHeight: "200px" }}
                    >
                      <div className="kt-grid kt-grid--hor kt-grid__item kt-grid__item--fluid kt-grid__item--middle">
                        <div className="kt-grid__item kt-grid__item--middle kt-align-center">
                          All caught up!
                          <br />
                          No new notifications.
                        </div>
                      </div>
                    </div>
                  </Tab.Pane>*/}
                </Tab.Content>
              </Tab.Container>
            </div>
          </form>
        </Dropdown.Menu>
      </Dropdown>
      </OverlayTrigger>
      <Dialog open={this.state.sessionExpired}  aria-labelledby="form-dialog-title" maxWidth="xs" fullWidth={true}>
 
      <DialogTitle id="form-dialog-title">Session Expired</DialogTitle>
      <DialogContent>
      <div className="kt-login__body">
        <div className="kt-login__form">
          <div className="kt-login__title">
            <h5>
              Your session has expired. Please login again to continue working.
            </h5>
          </div>

          <Formik
           initialValues={{
            email: this.state.email,
            password:""
           }}
            validate={values => {
              const errors = {};

              if (!values.email) {
               
                errors.email = "Required field";
              } else if (
                !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
              ) {
                errors.email = "Invalid email";
              }

              if (!values.password) {
                errors.password = "Required Field";
              }

              return errors;
            }}
            onSubmit={(values, { setStatus, setSubmitting }) => {
              //console.log('login');

             
             
                login(values.email, values.password)
                  .then(resp => {
                    //console.log("response auth::::",resp);
                    //console.log("response auth::::",resp.data);
                    if(resp.data === null || resp.data === undefined || resp.data.error === "invalid_grant")
                    {
                      
                      setSubmitting(false);
                       this.setState({status:"Invalid Username or password"});
                        
                      console.log("error login");
                    }
                    else
                    {
                      localStorage.setItem(TOKEN_PREFIX+'_access_token', resp.data.access_token);
                     
                      this.setState({sessionExpired:false});
                      window.location.reload();
                    }
                  })
                  .catch(() => {
                   
                    setSubmitting(false);
                    this.setState({status:"Invalid Username or password"});
                    console.log("error login");
                  });
             
            }}
          >
            {({
              values,
              status,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              isSubmitting
            }) => (
              <form
                noValidate={true}
                autoComplete="off"
                className="kt-form"
                onSubmit={handleSubmit}
              >
                {this.state.status ? (
                  <div role="alert" className="alert alert-danger">
                    <div className="alert-text">{this.state.status}</div>
                  </div>
                ) : <div></div>}

                <div className="form-group">
                  <TextField
                    type="email"
                    label="Email"
                    margin="normal"
                    className="kt-width-full"
                    name="email"
                    disabled={true}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.email}
                    helperText={touched.email && errors.email}
                    error={Boolean(touched.email && errors.email)}
                  />
                </div>

                <div className="form-group">
                  <TextField
                    type="password"
                    margin="normal"
                    label="Password"
                    className="kt-width-full"
                    name="password"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.password}
                    helperText={touched.password && errors.password}
                    error={Boolean(touched.password && errors.password)}
                  />
                </div>

                <div className="kt-login__actions">
                  <button
                    id="kt_login_signin_submit"
                    type="submit"
                    disabled={isSubmitting}
                    className={`btn btn-primary btn-elevate kt-login__btn-primary`}
                  >
                    Sign In
                  </button>
                  &nbsp;&nbsp;&nbsp;
                  <Link
                    to="/logout"
                    className="btn btn-label-brand btn-sm"
                  >
                    Not you? Logout
                </Link>
                </div>
                
              </form>
            )}
          </Formik>

         

         
        </div>



      </div>
     
      </DialogContent>


      

    </Dialog>
    </>
    );
  }
}
